import { useEffect } from "react";

import { useRouter } from "next/router";

import { FEATURE_ROUTES } from "@musicfy/components/Navigation/constants";
import PageLoader from "@musicfy/components/PageLoader";
import { useApiAccess } from "@musicfy/libs/ApiAccessProvider/hooks";

export default function PublicAPI() {
  const router = useRouter();

  const { isLoading, hasApiAccess } = useApiAccess();

  useEffect(() => {
    router.push(FEATURE_ROUTES.usage);
  }, [hasApiAccess, router]);

  if (isLoading || hasApiAccess) {
    return <PageLoader />;
  }

  return null;
}
